import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/caixas_convite';

function CaixasConvite() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ descricao: '', valor_unitario: '', quantidade: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ descricao: '', valor_unitario: '', quantidade: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({ descricao: item.descricao, valor_unitario: item.valor_unitario, quantidade: item.quantidade });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Convite dos padrinhos</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Descrição" name="descricao" value={form.descricao} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Valor unitário" name="valor_unitario" value={form.valor_unitario} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Quantidade" name="quantidade" value={form.quantidade} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && <Button onClick={() => { setEditId(null); setForm({ descricao: '', valor_unitario: '', quantidade: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell>Valor unitário</TableCell>
            <TableCell>Quantidade</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.descricao}</TableCell>
              <TableCell>{item.valor_unitario}</TableCell>
              <TableCell>{item.quantidade}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default CaixasConvite;
